import { axios } from '@repo/http';
import { organization_team_path } from '@repo/routes';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { orgTeamList } from '../organization-team-list';
import { teamQuery } from './team';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useUpdateTeam() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    return useMutation({
        mutationFn: (param)=>{
            let { teamId, data } = param;
            return axios.post("/v2/team/".concat(teamId), data);
        },
        onSuccess: async (res, param)=>{
            let { teamId, data, organizationName } = param;
            await Promise.all([
                queryClient.invalidateQueries(orgTeamList.teamList({
                    organization: organizationName
                })),
                queryClient.invalidateQueries(teamQuery.getById(teamId))
            ]);
            void navigate({
                to: organization_team_path({
                    team: {
                        name: data.name
                    },
                    organization: {
                        name: organizationName
                    }
                })
            });
        }
    });
}
